import { MealType } from "@fitness-app/data-models/entities/Dish";

export const weekdaysTranslation = {
  monday: "Poniedziałek",
  tuesday: "Wtorek",
  wednesday: "Środa",
  thursday: "Czwartek",
  friday: "Piątek",
  saturday: "Sobota",
  sunday: "Niedziela",
} as const;

export const mealTranslation = {
  [MealType.BREAKFAST]: "Śniadanie",
  [MealType.DINNER]: "Obiad",
  [MealType.SUPPER]: "Kolacja",
  [MealType.SNACK]: "Przekąska",
  [MealType.LUNCH]: "Lunch",
  [MealType.SECOND_BREAKFAST]: "II śniadanie",
} as const;

export const measureTranslations: Record<string, string> = {
  none: "Brak",
  handful: "Garść",
  spoon: "Łyżka",
  piece: "Sztuka",
  liter: "Litr",
  portion: "Porcja",
  smallSlice: "Plasterek",
  package: "Opakowanie",
  slice: "Plaster",
  teaspoon: "Łyżeczka",
  leaf: "Liść",
  glass: "Szklanka",
  cube: "Kostka",
  clove: "Ząbek",
  stalk: "Łodyga",
  drop: "Kropla",
  pinch: "Szczypta",
  flake: "Płatek",
  tube: "Rurka",
  capsule: "Kapsułka",
  scoop: "Miarka",
  bunch: "Pęczek",
  tablet: "Tabletka",
  gram: "g",
  ml: "ml",
};
